import type { StoreType } from '@gozoki/api-types'

export const storeTypeLabel: Record<StoreType, string> = {
  BOUTIQUE: 'Boutique',
  SHIPPING: 'Transport',
  WAREHOUSE: 'Entrepot',
  POUBELLE: 'Poubelle',
  INTERNAL_STOCK: 'Stock interne',
  REMOTE: 'Distanciel',
}

export const getInventoryStatusLabel = (status: string): string => {
  switch (status) {
    case 'validated': {
      return 'Validé'
    }
    case 'pending': {
      return 'En cours'
    }
    case 'canceled': {
      return 'Annulé'
    }
    default: {
      return status
    }
  }
}
